module.exports = __webpack_public_path__ + "img/stamp.99138737.svg";